import AMFlag from 'shared/icons/flags/am_flag.svg'
import BYFlag from 'shared/icons/flags/by_flag.svg'
import GBFlag from 'shared/icons/flags/gb_flag.svg'
import KGFlag from 'shared/icons/flags/kg_flag.webp'
import KZFlag from 'shared/icons/flags/kz_flag.svg'
import MDFlag from 'shared/icons/flags/md_flag.svg'
import RUFlag from 'shared/icons/flags/ru_flag.svg'
import TJFlag from 'shared/icons/flags/tj_flag.svg'
import USFlag from 'shared/icons/flags/us_flag.svg'
import UZFlag from 'shared/icons/flags/uz_flag.svg'

export const CountriesPhone = {
  KG: {
    dial_code: '+996',
    code: 'KG',
    flag: KGFlag,
    name: 'kyrgyzstan',
    length: 9,
  },
  BY: {
    dial_code: '+375',
    code: 'BY',
    flag: BYFlag,
    name: 'belarus',
    length: 9,
  },
  AM: {
    dial_code: '+374',
    code: 'AM',
    flag: AMFlag,
    name: 'armenia',
    length: 8,
  },
  KZ: {
    dial_code: '+7',
    code: 'KZ',
    flag: KZFlag,
    name: 'kazakhstan',
    length: 10,
  },
  MD: {
    dial_code: '+373',
    code: 'MD',
    flag: MDFlag,
    name: 'moldova',
    length: 8,
  },
  RU: {
    dial_code: '+7',
    code: 'RU',
    flag: RUFlag,
    name: 'russia',
    length: 10,
  },
  TJ: {
    dial_code: '+992',
    code: 'TJ',
    flag: TJFlag,
    name: 'tajikistan',
    length: 9,
  },
  UZ: {
    dial_code: '+998',
    code: 'UZ',
    flag: UZFlag,
    name: 'uzbekistan',
    length: 9,
  },
  GB: {
    dial_code: '+44',
    code: 'GB',
    flag: GBFlag,
    name: 'united_kingdom',
    length: 10,
  },
  US: {
    dial_code: '+1',
    code: 'US',
    flag: USFlag,
    name: 'united_states',
    length: 10,
  },
}

export const CountriesPhoneList = Object.keys(CountriesPhone)?.map((key) => ({
  ...CountriesPhone[key as keyof typeof CountriesPhone],
}))
